import React from 'react'
import { useContent } from '../../services'
import Contactbanner from '../Mencontactus/Contactbanner'
import Bredcrumb from '../Bredcrumb/Main'
import PageSEO from '../SEO/PageSEO'
import Img from '../../assets/images/background/banner-image-4.jpg'

const BREADCRUMB_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://www.huqup380.com/' },
    { '@type': 'ListItem', position: 2, name: 'Contact', item: 'https://www.huqup380.com/contact' }
  ]
}

function Main() {
  const { data, loading } = useContent('contactContent');

  if (loading || !data) return null;

  const { breadcrumb } = data;

  return (
    <>
      <PageSEO
        title="Contact Us"
        description="Contact Huq Up - Cafe & Grill. 27052 E University Dr Suite 100, Little Elm, TX 75068. Call (469) 724-1846 or email info@huqup380.com."
        canonical="https://www.huqup380.com/contact"
        structuredData={BREADCRUMB_SCHEMA}
      />
      <Bredcrumb title={breadcrumb.title} subtitle={breadcrumb.subtitle} Img={Img} />
      <Contactbanner />
    </>
  )
}

export default Main
